import { useState } from "react";
import EventForm from "./components/EventForm";
import Results from "./components/Results";
import { PlaygroundResponseType } from "./api/play-api";
import { Link } from "react-router-dom";
import { History } from "lucide-react";

const PlaygroundView = () => {
  const [resultData, setResultData] = useState<PlaygroundResponseType>()
  const [eventId, setEventId] = useState(0)
  return (
    <div className="mt-[5vh] w-full relative">
      <Link to="history" className="bg-black p-2 text-sm text-white rounded-lg absolute top-5 right-5 flex items-center gap-2">
        <History size={14} />
        <span className="hidden sm:block">
          Previous Events
        </span>
      </Link>
      <h2 className="w-full text-center text-3xl font-montserrat pt-5">Welcome to siAi Playground</h2>
      <p className="w-full text-center text-gray-500 pb-5">Please wait 2-3 minutes till siAi generates</p>
      <EventForm setResult={setResultData} setEventId={setEventId} />
      {resultData && <Results result={resultData} eventId={eventId} setEventId={setEventId} />}
    </div>
  )
}

export default PlaygroundView;
